export const SET_USER_IDENTIFICATION = "SET_USER_IDENTIFICATION";
export const GET_USER_IDENTIFICATION = "GET_USER_IDENTIFICATION";

export const SET_USER_AUTHORIZATION = "SET_USER_AUTHORIZATION";
export const GET_USER_AUTHORIZATION = "GET_USER_AUTHORIZATION";